import { addListener, launch, crashBrowserCurrentTab, isLaunch, stop } from 'devtools-detector';
import { showVconsole, isServe, isProd } from '@/env'

addListener((isOpen) => {
  if (isOpen) setTimeout(crashBrowserCurrentTab, 1000);
});

if (!showVconsole && !isServe && isProd) {
  launch()

  document.addEventListener('visibilitychange', () => {
    if (document.hidden || document.visibilityState === 'hidden') {
      stop()
    } else {
      if (!isLaunch()) launch()
    }
  })
}
